import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.tr`
  ${({ theme, displayState }) => css`
    cursor: pointer;

    &:hover {
      color: ${theme?.colour?.primary};
    }

    th {
      border: solid 1px;
      border-right: none;
      padding-left: 30px;
      border-radius: 0px 0px 0px 0px;
      background-color: white;
    }
    td {
      border: solid 1px;
      border-style: solid none;
      border-color: #E3E3E3;
      background-color: ${displayState === 'selected' ? '#1DBD6B' : 'transparent'};
      height: 63px;
      min-width: 100px;
      padding-right: 20px;
      white-space: nowrap;
    }
    td:last-child {
      border-right-style: solid;
      border-radius: 0px 0px 0px 0px;
    }
  `}
`;

export default Wrapper(template)
